import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import CoachSelect from '../../../components/Leads/components/CoachSelect';
import texts from '../texts.json';
import SectionCard from './SectionCard';

const CoachSection = ({ resetKey, onChange }) => {
  const handleChange = useCallback((option) => {
    if (!option || !option.id) {
      onChange(null);
      return;
    }
    onChange({ id: option.id, name: option.label });
  }, [onChange]);

  return (
    <SectionCard title={texts.sections.coach.title}>
      <CoachSelect
        key={resetKey}
        onChange={handleChange}
        loadNewCoachDataOnChange={false}
        hideLabel
      />
    </SectionCard>
  );
};

CoachSection.propTypes = {
  resetKey: PropTypes.number,
  onChange: PropTypes.func.isRequired,
};

CoachSection.defaultProps = {
  resetKey: 0,
};

export default CoachSection;
